import Carousel from '../../components/base/Carousel';

// Инициализация карусели

function initCarousel(carouselWrapper) {
    const productCarousel = new Carousel($(carouselWrapper).find('.carousel--product-pictures'));
    const thumbnailsCarousel = new Carousel($(carouselWrapper).find('.carousel--product-thumbnails'));
    const thumbnailsCarouselMobile = new Carousel($(carouselWrapper).find('.carousel--product-thumbnails-mobile'));

    const lightParams = {
        spaceBetween: 8,
        loop: false,
    };

    const hardParams = {
        slidesPerView: 4,
        preventClicks: false,
        preventClicksPropagation: false,
        virtualTranslate: false,
        simulateTouch: false,
    };

    /**
     * Подсветка активного слайда у карусели миниатюр
     *
     * @param {string} id - id активного слайда
     */
    const updateCarouselThumbnails = id => {
        // Карусели две (мобильный, десктопный). Обрабатываем каждый
        $(carouselWrapper)
            .find(`[data-related="#${id}"]`)
            .each((i, item) => {
                const $thumbnail = $(item);
                const carouselInstance = Carousel.getInstance($thumbnail.closest('.carousel')).instance;

                carouselInstance.slideTo($thumbnail.index());
                $thumbnail
                    .parent()
                    .find('.swiper-slide')
                    .removeClass('is-selected');
                $thumbnail.addClass('is-selected');
            });
    };

    /**
     * При клике на карусель миниатюр, выбираем соответствующий выбранный слайд
     *
     * @param {Object} event - Событие
     * @param {Object} event.currentTarget - Текущий элемент
     */
    const onThumbnailSelected = ({ currentTarget }) => {
        const $target = $(currentTarget);
        const id = $target.attr('data-related');
        const index = Number($(id).attr('data-swiper-slide-index'));

        updateCarouselThumbnails(id);

        productCarousel.instance.slideTo(index);
    };

    /**
     * Актуализация боковой панели, при свайпе карусели изображений
     */
    function onProductSwipe() {
        const { realIndex, slides } = this;
        const currentSlideId = slides[realIndex].getAttribute('id');

        updateCarouselThumbnails(currentSlideId);
    }

    /**
     * Инициализацию карусели лучше всего делать после загрузки страницы,
     * так как он подвязан на размеры блоков
     */
    $(document).ready(() => {
        setTimeout(() => {
            // Инициализация каруселей миниатюр на десктопе
            thumbnailsCarousel.init(
                {
                    ...lightParams,
                    vertical: true,
                },
                hardParams
            );

            // Инициализация каруселей миниатюр на десктопе
            thumbnailsCarouselMobile.init(lightParams, hardParams);

            // Инициализации карусели изображений
            productCarousel.init({}, { slidesPerView: 1 });
            const productCarouselInstance = productCarousel.instance;

            // Актуализация слайдера миниатюр
            onProductSwipe.call(productCarouselInstance);

            // Свайп карусели изображений
            productCarouselInstance.on('slideChange', onProductSwipe);

            // Клик по миниатюре
            $(document).on('click', '.js-product-carousel-wrapper [data-related]', onThumbnailSelected);

            /**
             * Если внутри слайда видеоролик, ставим на паузу при переключении
             */
            productCarouselInstance.on('slideChangeTransitionEnd', () => {
                const $wrapperEl = $(productCarouselInstance.wrapperEl);

                const $iframe = $wrapperEl.find('iframe');

                $iframe.each((i, iframe) => {
                    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                });
            });
        }, 100);
    });
}

export default initCarousel;
